export const TOPICS = 'TOPICS';
export const TOPIC = 'TOPIC';


// WEBPACK FOOTER //
// ./src/store/modules/topic/mutation-types.js